import {
  TPatientCardInfo,
  TPatientDupCheckPhoneNumParams,
  TPatientInfoResponse,
  TPatientListParams,
  TPatientListResponse,
  TPatientSimpleList,
} from 'types/apis/patient';
import { createService } from './config/axios';
import qs from 'qs';

export const postPatientDupCheckPhoneNum = async (
  data: TPatientDupCheckPhoneNumParams
) =>
  await createService({
    url: `/student-patient/phone-dup-check/${data.phoneNum}`,
    options: {
      method: 'post',
      data,
    },
  });

export const postPatient = async (data: FormData) =>
  await createService({
    url: '/student-patient',
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data,
    },
  });

export const getPatientList = async (params: TPatientListParams) => {
  const queryString = qs.stringify(params);
  const url = queryString
    ? `/student-patient?${queryString}`
    : '/student-patient';

  return await createService<TPatientListResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getPatientSimpleList = async () =>
  await createService<TPatientSimpleList>({
    url: '/student-patient/simple-list',
    options: {
      method: 'get',
    },
  });

export const getPatientInfo = async (patientId: string) =>
  await createService<TPatientInfoResponse>({
    url: `/student-patient/${patientId}`,
    options: {
      method: 'get',
    },
  });

export const getPatientCardInfo = async (patientId: string) =>
  await createService<TPatientCardInfo>({
    url: `/student-patient/with-chart/${patientId}`,
    options: {
      method: 'get',
    },
  });

export const putPatient = async (patientId: string, data: FormData) =>
  await createService({
    url: `/student-patient/${patientId}`,
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'put',
      data,
    },
  });

export const deletePatient = async (patientId: string) =>
  await createService({
    url: `/student-patient/${patientId}`,
    options: {
      method: 'delete',
    },
  });
